import Footer from "./Footer";

export {Footer}
export default Footer